// extracted by mini-css-extract-plugin
export default {"wrapper":"privacy_wrapper__zyvSp","title":"privacy_title__PMK5W","contents":"privacy_contents__RInbP"};